package club.srams.website.components.sections

import androidx.compose.runtime.*
import club.srams.website.components.widgets.CloseButton
import club.srams.website.components.widgets.ColorModeButton
import club.srams.website.components.widgets.DropdownMenuComponent
import club.srams.website.components.widgets.HamburgerButton
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.overlay.Overlay
import com.varabyte.kobweb.silk.components.overlay.OverlayVars
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*
import club.srams.website.toSitePalette
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText

val NavHeaderStyle = CssStyle.base {
    Modifier.fillMaxWidth().padding(1.cssRem)
}

@Deprecated("do not use")
@Composable
private fun NavLink(
    path: String
    , text: String
) {
    Link(
        path
        , text
        , variant = UndecoratedLinkVariant
            .then(UncoloredLinkVariant)
    )
}

@Composable
private fun MenuItem(
    selected: Boolean = false,
    text: @Composable () -> Unit,
    onClick: () -> Unit

) {
//    Column(
//        modifier = Modifier
//            .userSelect(UserSelect.None)
//            .minWidth(48.px),
//        horizontalAlignment = Alignment.CenterHorizontally,
//        verticalArrangement = Arrangement.spacedBy(4.px)
//    ) {
        Box(
            modifier = Modifier
                .onClick { onClick() }
        ) {
            text()
        }
//    }
}

@Composable
private fun MenuComponents(

) {
    val pageContext = rememberPageContext()
    fun navigateToPage(path: String) = pageContext.router.navigateTo(path)

    MenuItem(
        text = {SpanText("Home")}
        , onClick = {navigateToPage("/")}
    )
    MenuItem(
        text = {SpanText("Pebble Pups")}
        , onClick = {navigateToPage("/pebble-pups-v2")}
    )
    MenuItem(
        text = {EventsDropdownMenu()}
        , onClick = {}
    )
    MenuItem(
        text = {LearnDropdownMenu()}
        , onClick = {}
    )
    MenuItem(
        text = {SpanText("Awesome Places")}
        , onClick = {navigateToPage("/awesome-places")}
    )
    MenuItem(
        text = {SpanText("Contact Us")}
        , onClick = {navigateToPage("/contact-us")}
    )
    MenuItem(
        text = {SpanText("About")}
        , onClick = {navigateToPage("/about")}
    )
    ColorModeButton()
}

//
//@Deprecated("do not use")
//@Composable
//private fun MenuItems() {
//    NavLink("/", "Home")
//    NavLink("/pebble-pups-v2", "Pebble Pups")
//    NavLink("/contact-us", "Contact Us")
//    NavLink("/about", "About")
//    EventsDropdownMenu()
//    //NavLink("/field-trips-v2", "Field Trips")
//    //NavLink("/event-calendar", "Event Calendar")
//    //NavLink("/tailgate-swap-v2", "Tailgate Swap")
//}

@Composable
private fun EventsDropdownMenu() {

    val pageContext = rememberPageContext()
    val backgroundColor = if (ColorMode.current == ColorMode.LIGHT) Colors.White else Colors.Black
    val textColor = if (ColorMode.current == ColorMode.LIGHT) Colors.Black else Colors.White

    // Map labels to their routes
    val itemRoutes = mapOf(
        "Calendar"    to "/event-calendar",
        "Field Trips" to "/field-trips-v2",
        "Tailgate"    to "/tailgate-swap-v2"
    )

    Column(
        modifier = Modifier
            .fillMaxWidth()
            //.padding(32.px)
        , horizontalAlignment = Alignment.CenterHorizontally
    ) {
        DropdownMenuComponent(
            label = "Events"
            , items = itemRoutes.keys.toList()
            , onItemSelected = { item ->
                itemRoutes[item]?.let { route ->
                    pageContext.router.navigateTo(route)
                }

            }
            , color = textColor
            , backgroundColor = backgroundColor
        )
    }

}


@Composable
private fun LearnDropdownMenu() {

    val pageContext = rememberPageContext()
    val backgroundColor = if (ColorMode.current == ColorMode.LIGHT) Colors.White else Colors.Black
    val textColor = if (ColorMode.current == ColorMode.LIGHT) Colors.Black else Colors.White

    // Map labels to their routes
    val itemRoutes = mapOf(
        "Identify Rocks"    to "/learn_identify_rocks",
        "Tumble Rocks"      to "/learn_tumble_rocks",
    )

    Column(
        modifier = Modifier
            .fillMaxWidth()
        //.padding(32.px)
        , horizontalAlignment = Alignment.CenterHorizontally
    ) {
        DropdownMenuComponent(
            label = "Learn"
            , items = itemRoutes.keys.toList()
            , onItemSelected = { item ->
                itemRoutes[item]?.let { route ->
                    pageContext.router.navigateTo(route)
                }

            }
            , color = textColor
            , backgroundColor = backgroundColor
        )
    }

}

val SideMenuSlideInAnim = Keyframes {
    from {
        Modifier.translateX(100.percent)
    }

    to {
        Modifier
    }
}

// Note: When the user closes the side menu, we don't immediately stop rendering it (at which point it would disappear
// abruptly). Instead, we start animating it out and only stop rendering it when the animation is complete.
enum class SideMenuState {
    CLOSED,
    OPEN,
    CLOSING;

    fun close() = when (this) {
        CLOSED -> CLOSED
        OPEN -> CLOSING
        CLOSING -> CLOSING
    }
}

@Composable
fun NavHeader() {
    Row(NavHeaderStyle.toModifier(), verticalAlignment = Alignment.CenterVertically) {
        // Block display overrides inline display of the <img> tag, so it calculates centering better
        Image(
            "/images/logo-large.jpg"
            , "SRAMS Logo"
            , Modifier
                .height(8.cssRem)
                .display(DisplayStyle.Block)
                .objectFit(ObjectFit.Cover)
                .borderRadius(25.percent)
        )

        Spacer()

        Row(
            Modifier
                .gap(1.5.cssRem)
                .displayIfAtLeast(Breakpoint.MD)
            , verticalAlignment = Alignment.CenterVertically
        ) {
            MenuComponents()
            //MenuItems()
            //ColorModeButton()
        }

        Row(
            Modifier
                .fontSize(1.5.cssRem)
                .gap(1.cssRem)
                .displayUntil(Breakpoint.MD),
            verticalAlignment = Alignment.CenterVertically
        ) {
            var menuState by remember { mutableStateOf(SideMenuState.CLOSED) }

            ColorModeButton()
            HamburgerButton(onClick =  { menuState = SideMenuState.OPEN })

            if (menuState != SideMenuState.CLOSED) {
                SideMenu(
                    menuState,
                    close = { menuState = menuState.close() },
                    onAnimationEnd = { if (menuState == SideMenuState.CLOSING) menuState = SideMenuState.CLOSED }
                )
            }
        }
    }
}

@Composable
private fun SideMenu(menuState: SideMenuState, close: () -> Unit, onAnimationEnd: () -> Unit) {
    Overlay(
        Modifier
            .setVariable(OverlayVars.BackgroundColor, Colors.Transparent)
            .onClick { close() }
    ) {
        key(menuState) { // Force recompute animation parameters when close button is clicked
            Column(
                Modifier
                    .fillMaxHeight()
                    .width(
                        clamp(
                            8.cssRem
                            , 40.percent
                            , 10.cssRem
                        )
                    )
                    .align(Alignment.CenterEnd)
                    // Close button will appear roughly over the hamburger button, so the user can close
                    // things without moving their finger / cursor much.
                    .padding(top = 1.cssRem, leftRight = 1.cssRem)
                    .gap(1.5.cssRem)
                    .backgroundColor(ColorMode.current.toSitePalette().nearBackground)
                    .animation(
                        SideMenuSlideInAnim.toAnimation(
                            duration = 200.ms,
                            timingFunction = if (menuState == SideMenuState.OPEN) AnimationTimingFunction.EaseOut else AnimationTimingFunction.EaseIn,
                            direction = if (menuState == SideMenuState.OPEN) AnimationDirection.Normal else AnimationDirection.Reverse,
                            fillMode = AnimationFillMode.Forwards
                        )
                    )
                    .borderRadius(topLeft = 2.cssRem)
                    .onClick { it.stopPropagation() }
                    .onAnimationEnd { onAnimationEnd() },
                horizontalAlignment = Alignment.End
            ) {
                CloseButton(onClick = { close() })
                Column(
                    Modifier.padding(right = 0.75.cssRem)
                        .gap(1.5.cssRem)
                        .fontSize(1.cssRem)
                    , horizontalAlignment = Alignment.End
                ) {
                    MenuComponents()
                    // MenuItems()
                }
            }
        }
    }
}
